import { Box, Grid } from '@mui/material';
import theme from 'theme';
import { TeamHardwareRequestsTable } from './table';

const TeamHardwareRequestsView = () => (
  <Box sx={{ padding: theme.spacing(4) }}>
    <Grid container spacing={4}>
      <Grid
        size={{
          lg: 12,
          md: 12,
          xl: 12,
          xs: 12,
        }}
      >
        <TeamHardwareRequestsTable />
      </Grid>
    </Grid>
  </Box>
);

export default TeamHardwareRequestsView;
